/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RouterStatusDto } from '../../models/router-status-dto';

export interface ReceiveRouterStatus$Params {
  vendor: string;
      body?: RouterStatusDto
}

export function receiveRouterStatus(http: HttpClient, rootUrl: string, params: ReceiveRouterStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<RouterStatusDto>> {
  const rb = new RequestBuilder(rootUrl, receiveRouterStatus.PATH, 'post');
  if (params) {
    rb.path('vendor', params.vendor, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RouterStatusDto>;
    })
  );
}

receiveRouterStatus.PATH = '/api/{vendor}/router/status';
